export const defaultVersion = {
  prefix: 'v',
  number: 1
};

export const endpoints = {
  v1: {
    login: 'authentication/login/',
    refresToken: 'authentication/refresh-token/',
    category: 'category/{idCategoria}/',
    process: 'process/{idProceso}/',
    processCategory: 'process-category/{idCategoria}/',
    defaultTramites: 'default-tramites/{idTramite}/',
    defaultStatusTramite: 'default-status-tramite/',
    adminDefaultWorkflowTramite: 'admin-default-workflow-tramite/{idTramite}/',
    defaultStatusActivity: 'default-status-activity/',
    statusActivity: 'status-activity/',
    tramiteProcess: 'tramite-process/{idProceso}/',
    instanceDefaultTramite: 'instance-default-tramite/{idDefaultTramite}/',
    microprocesInstance: 'microproces-instance/{idTarea}/',
    instanceTramite: 'instance-tramite/{idTramite}/',
    instanceMethods: 'instance-methods/',
    assignment: 'task-assignment-responsible/',
    roles: 'roles/{idRol}/',
    rolesUsers: 'roles-users/{idRol}/',
    defaultCompensation: 'default-compensation/{idDefaultCompensation}/',
    defaultRecommendation: 'default-recommendation/{idDefaultRecommendation}/',
    defaultConclusion: 'default-conclusion/{idDefaultConclusion}/',
    defaultObligation: 'default-obligation/{idDefaultObligation}/',
    species: 'species/{idSpecie}/',
    typeSpecies: 'type-species/',
    unitsMeasure: 'units-measure/',
    typeMobilization: 'type-mobilization/',
    classSisf: 'class-sisf/',
    holidays: 'holidays/{idHoliday}/',
    specialDays: 'special-days/{idSpecialDay}/',
    docsInstance: 'document-instance/{idDocumento}/',
    historyDocsInstance: 'history-document-instance/{idDocumento}/',
    reviewDocument: 'review-document/',
    radication: 'radication-document/{idDocumento}/',
    typeField: 'type-fields/',
    dynamicForm: 'dynamic-form/{idForma}/',
    dynamicFormVersion: 'dynamic-form-version/',
    masterTable: 'master-table/{idMaster}/',
    dynamicFormInstance: 'dynamic-form-instance/{idTarea}/',
    dynamicFormInstanceStructure: 'dynamic-form-instance-structure/{id}/',
    typeTask: 'type-task/',
    defaultTypeTask: 'default-type-task/',
    statusTask: 'status-task/',
    defaultStatusTask: 'default-status-task/',
    defaultMicroproces: 'default-microproces/{idMicroproces}',
    defaultTypeCompletion: 'default-type-completion/{idType}/',
    typeCompletion: 'type-completion',
    defaultDocument: 'default-document/',
    defaultFunction: 'default-function/',
    typeAssociation: 'type-association/{id}/',
    taskTramiteDefault: 'task-tramite-default/{idTramite}/',
    masterTableInformation: 'master-table-information/{idMasterTable}/',
    activityCalendar: 'activity-calendar/{idUsuario}/',
    defaultTask: 'default-task/{id}/',
    structureMasterTable: 'structure-master-table/{idStructure}/',
    masterTableSpecificInformation: 'master-table-specific-information/',
    documentGeneration: 'document-generation/',
    chargeTaskData: 'charge-task-data/{idTask}/',
    duplicateDefaultTramite: 'duplicate-default-tramite/',
    radicationDocument: 'radication-document/{idTarea}/',
    dynamicReport: 'dynamic-report/',
    historyTask: 'history-task/{idTask}',
    rejectTask: 'reject-task/',
    reportTraceability: 'report-traceability/',
    usersManagement: 'users-management/{idUser}/',
    company: 'company/{id}/',
    emailSmtp: 'admin-email-smtp/{id}/',
    emailSmtpCompany: 'admin-email-smtp-company/{idCompany}/',
    sedesManagement: 'sedes-management/{idCompany}/',
    dependencies: 'dependencies/{id}/',
    chargeMasterData: 'charge-master-data/{idMaestra}/',
    historyMicroproces: 'history-microproces/{idTask}/',
    generateRadicationCita: 'generate-radication-cita/',
    workingDays: 'working-days/',
    synchronizationForms: 'synchronization-forms/{id}/',
    duplicateForms: 'duplicate-forms/',
    rolesPermissions: 'roles-permissions/{id}/',
    typePermissions: 'type-permissions/{idType}/',
    rolesTramite: 'roles-tramite/{idTramite}/',
    adminReports: 'admin-reports/{idReport}/',
    typeReports: 'type-reports/',
    reportTramites: 'report-tramites/{idReport}/',
    structureReport: 'structure-report/{idReport}/',
    tramiteTasks: 'tramite-tasks/{idTramite}/',
    microprocessTasks: 'microprocess-tasks/{idTask}/',
    categoryReports: 'category-reports/{idCategory}/',
    typeReportParameter: 'type-report-parameter/',
    filterReportParameterInstance: 'filter-report-parameter-instance/{id}/',
    filterReportParameter: 'filter-report-parameter/{id}/',
    statusExpediente: 'status-expediente/{idStatus}/',
    filterTramiteParameter: 'filter-tramite-parameter/{idTramite}/',
    generateRecordCover: 'generate-record-cover/{idDocumento}/',
    tramiteUserProcess: 'tramite-user-process/{idProcess}/',
    processUser: 'process-user/{idCategory}/',
    categoryUser: 'category-user/',
    adminSecondary: 'admin-secondary/{idSecondary}/',
    adminSecondaryWorkflow: 'admin-secondary-workflow/{idSecondary}/',
    adminSecondaryMicroprocessWorkflow: 'admin-secondary-microprocess-workflow/{idTask}/',
    instanceSecondaryWorkflow: 'instance-secondary-workflow/{id}/',
    instanceSecondaryCancelation: 'instance-secondary-cancelation/',
    liquidation: 'liquidation/',
    liquidations: 'liquidations/',
    taskExpediente: 'task-expediente/{idTask}',
    documentAssociateProcess: 'document-associate-process/',
    associateProcess: 'associate-process/',
    associatedTask: 'associated-task/{idTask}/',
    attachedDocument: 'attached-document/{id}/',
    downloadAttachedDocument: 'download-attached-document/{id}/',
    consecutiveActDocument: 'consecutive-act-document/',
    taskSpecialOptions: 'task-special-options/{id}/',
    dataCharge: 'data-charge/{id}/',
    defaultDynamicTaskForm: 'default-dynamic-task-form/{idForm}/',
    dynamicView: 'dynamic-view/{id}/',
    dynamicViewDetail: 'dynamic-view-detail/',
    instanceViewMethods: 'instance-view-methods/',
    adminSerie: 'admin-serie/{id}/',
    adminSubSerie: 'admin-subserie/{id}/',
    adminTypeDocument: 'type-documentary/{id}/',
    adminDocument: 'admin-document/{id}/',
    adminDocumentGeneration: 'admin-document-generation/{id}/',
    adminTypeDocumentGeneration: 'admin-type-document-generation/{id}/',
    adminDocumentPreviewDocument: 'admin-preview-document/{id}/',
    chargeUsers: 'charge-users/{idCharge}/',
    changeUserPassword: 'change-user-password/',
    publicationService: 'publication-service/',
    observationProcess: 'observation-process/{id}/',
    typeService: 'type-service/{id}/',
    processTitles: 'process-titles/{id}/',
    titles: 'titles/',
    stageInstanceTimes: 'stage-instance-times/{id}/',
    searchDependencie: 'search-dependencies/',
    adminBulletin: 'admin-bulletin/{id}/',
    adminPublicationDetail: 'admin-publication-detail/{id}/',
    adminPublication: 'admin-publication/{id}/',
    downloadDocumentPublication: 'download-document-publication/{id}/',
    radicados_cita: 'search_radicades/',
    anios_radicados: 'associate-radication-utilities/{id}/',
    consecutives: 'admin-consecutives/{id}/',
    estructure: 'structure-radication/{id}/',
    add_details: 'admin-consecutive-detail/{id}/',
    structure_types: 'type-structure-radication/',
    structure_detail: 'structure-radication-detail/{id}/',
    sticker_document: 'sticker-document/{id}/',
    download_sticker: 'sticker-document-download/{id}/',
    generateStickerDoc: 'generate-sticker-document/',
    radicationUtilities: 'radication-utilities/{id}/',
    documentAnswer: 'document-answer/{id}/',
    search_users_dependencies: 'users-headqueaters/{id}/',
    responsible_document: 'responsible-document/{id}/',
    copy_to_document: 'copy-users-document/{id}/',
    document_expedient: 'exp-document/{id}/',
    control_documentary: 'selector-type-document/{id}/',
    existing_control_documentary: 'instance-selection-document/{id}/',
    tramiteProcessCategory: 'tramite-process-category/{id}/',
    selectorUtil: 'selector-util/{id}/',
    selectorUtils: 'selector-utils/',
    getInformationTask: 'task/{id}/',
    liquidationCinco: 'liquidation-cinco/{id}/',
    cancelLiquidationCinco: 'cancel-liquidation-cinco/{id}/',
    reassignTask: 'reassigment-responsible/',
    annul: 'annulation/{id}/',
    getAnnul: 'annulation-procedure/{id}/',
    adminAnnulation: 'admin-process-annulation/{id}/',
    filterSelector: 'filter-selector/',
    dynamicCalendar: 'search-dynamic-calendar/',
    dynamicProcedureStructure: 'search-dynamic-procedure-structure/',
    searchDynamicProcedure: 'search-dynamic-procedure/',
    externalPublication: 'external-publication/{id}/',
    externalBulletin: 'external-bulletin/{id}/',
    searchProcedureModalInfo: 'search-dynamic-modal/',
    iframeStructure: 'iframe-structure/{id}/',
    adminIframes: 'admin-iframes/{id}/',
    associateRadicationUtilitiesService: 'associate-radication-utilities-service/{id}/',
    removeLiquidation: 'remove-liquidation/{id}/',
    typeSearchFields: 'type-search-fields/{id}/',
    adminModals: 'admin-modals/{id}/',
    filterReport: 'filter-report-parameter-instance/{id}/',
    adminStages: 'admin-stages/{id}/',
    adminStagesDetail: 'admin-stages-detail/{id}/',
    adminStagesRange: 'admin-stages-range/{id}/',
    defaultActivity: 'default-activity/{id}/',
    adminTimeSuspensions: 'admin-suspension-times/{id}/',
    adminUsers: 'admin-user/{id}/',
    adminUsersWithoutLogin: 'admin-user-not-login/{id}/',
    adminRolesMaester: 'admin-roles-maester/{id}/',
    adminUserMasterPermission: 'admin-user-master-permissions/',
    autoNameUser: 'auto-name-user/',
    reassigmentResponsible: 'reassigment-responsible/{id}/',
    allUserSystem: 'all-users-system/',
    historyUsersInactivation: 'history-users-inactivation/{id}/',
    userInactivationReason: 'user-inactivation-reason/{id}/',
    categoryReportsInstance: 'category-reports-instance/{idCategory}/',
    adminRolesReports: 'admin-roles-reports/{id}/',
    sendDataService: 'send-data-service/{id}/',
    MultiUser: 'multi-user/{id}/',
    MultiUserDocument: 'multi-user-document/{id}/',
    TrdPermissions: 'trd-permissions/{id}/',
    TrdPermissionsSpecial: 'trd-permissions-special/{id}/',
    adminControlDocumentary: 'admin-selector-type-document/{id}/',
    masterTableData: 'master-table-data/{idMaster}&{offset}&{limit}/',
    adminDocumentAssessment: 'admin-documentary-assessment/{id}/',
    supportDocument: 'admin-document-support/{id}/',
    adminDocumentDependency: 'admin-document-dependency/{id}/',
    documentInventory: 'document-inventory/{id}/',
    documentInventorySearch: 'document-inventory-search/{id}/',
    documentExpInventory: 'document-exp-inventory/{id}/',
    documentExpInventorySearch: 'document-exp-inventory-search/{id}/',
    DocumentAssessment: 'documentary-assessment/{id}/',
    DocumentUtility: 'document-utility/{id}/',
    qrTypes: 'qr/{id}/',
    qrCategory: 'qr-util/{id}/',
    customSerachAdmin: 'custom-search-admin/{id}/',
    adminTypeDocumentSpecial: 'type-documentary-special/{id}/',
    stickerDocumentSpecial: 'sticker-document-special/{id}/',
    previewStickerDocument: 'preview-sticker/{id}/',
    attachedDocumentCustom: 'attached-document-custom/{id}/',
    advancedSearchs: 'advanced-search/{id}/',
    indicatorsSearchs: 'indicators/{id}/',
    utilitiesRequestedUser: 'utilities-requestd-user/{id}/',
    searchsStructureRadication: 'search-structure-radication/{id}/',
    procedureMonitoring: 'procedure-monitoring/{id}/',
    adminSecondaryDetail: 'admin-secondary-detail/{id}/',
    usersTask: 'users-task/{id}/',
    usersTaskHistory: 'users-task-history/{id}/',
    usersGroupTask: 'users-group-task/{id}/',
    adminFieldSearch: 'admin-field-search/{id}/',
    fieldSearch: 'field-search/{id}/',
    instanceTask: 'task-instance/{id}/',
    ViewVital: 'view-vital/{id}/',
    helps: 'helps/{id}/',
    categoryHelps: 'category-helps/{id}/',
    adminHelps: 'admin-helps/{id}/',
    adminCategoryHelps: 'admin-category-helps/{id}/',
    attachedDocumentProcedure: 'attached-document-procedure/{id}/',
    sentBy: 'sent-by-users-document/{id}/',
    selectorDynamic: 'selector-dynamic-util/{id}/',
    adminGeneric: 'admin-generic',
    tramiteGenericProcess: 'tramite-process-generic/{id}/',
    adminConsecutiveAct: 'admin-consecutive-act/{id}/',
    consecutiveAct: 'consecutive-act/{id}/',
    rolUser: 'rol-users/{id}/',
    modifyDocument: 'modify-document/{id}/',
    approveModifyDocument: 'approve-modify-document/{id}/',
    historyModifyDocument: 'history-modify-document/{id}/',
    associateDocument: 'associate-document/{id}/',
    serie: 'serie/{id}/',
    subSerie: 'sub-serie/{id}/',
    typeDocument: 'type-document-instance/{id}/',
  }
};



// WEBPACK FOOTER //
// ./src/api-endpoints.ts